import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Color from 'color';
import styled from 'styled-components';
import { getErrorId } from '@hivebrite/utils';
import { Box } from "../../box/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { useTheme } from "../../theme/src";
export const ErrorMessage = ({ error, iconColor = 'fire', id, mt = 2, }) => {
    const theme = useTheme();
    const iconExclamationMarkColor = theme.colors[iconColor] || iconColor;
    const errorId = getErrorId(id);
    return (_jsx(WhiteWrapper, { "data-testid": "ds-error-tag", id: errorId, mt: mt, children: _jsxs(LightFireBackground, { bg: Color(theme.colors.fire).alpha(0.1).string(), children: [_jsx(Box, { flexShrink: 0, children: _jsx(FontAwesomeIcon, { color: iconExclamationMarkColor, height: "16px", iconName: "circle-exclamation", iconType: CATEGORIES.SOLID }) }), _jsx(Box, { color: "asphalt", ml: 2, children: error })] }) }));
};
const WhiteWrapper = styled(Box).attrs(() => ({
    bg: 'white',
    minHeight: '32px',
})) `
  border-radius: 5px;
`;
const LightFireBackground = styled(Box).attrs(() => ({
    alignItems: 'center',
    px: 3,
    py: 1,
    width: '100%',
})) `
  border-radius: 5px;
`;
//# sourceMappingURL=ErrorMessage.js.map